namespace AgerLMS.Logging {
    export interface UserActivityRow {
        Id?: number;
        UserId?: number;
        UserActivityType?: UserActivityTypes;
        IpNo?: string;
        UserAgent?: string;
        AuthToken?: string;
        UserUsername?: string;
        UserDisplayName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace UserActivityRow {
        export const idProperty = 'Id';
        export const nameProperty = 'IpNo';
        export const localTextPrefix = 'Logging.UserActivity';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'Logging:UserActivity:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            UserId = "UserId",
            UserActivityType = "UserActivityType",
            IpNo = "IpNo",
            UserAgent = "UserAgent",
            AuthToken = "AuthToken",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
